import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { FloatingButton } from './floating-button';
import { toolbarStyling, iconStyling } from './styles';

type Props = {
  onClick: () => void;
};

export const DefaultButtonToolbar = ({ onClick }: Props) => {
  const { t } = useTranslation('content-composer');

  return (
    <FloatingButton onClick={onClick} css={{ ...toolbarStyling, fontWeight: theme.font.weight.bold }}>
      <Icon name='link' css={iconStyling} />
      <Text as='span'>{t('Link Button')}</Text>
    </FloatingButton>
  );
};
